import React from 'react'
import styled from 'styled-components'
import PreparePaymentsFileCard from 'modules/tools/components/PreparePaymentsFileCard'

const Tools = () => {
  return (
    <Wrapper>
      <PageHeader>Narzędzia</PageHeader>
      <CardsGrid>
        <PreparePaymentsFileCard />
      </CardsGrid>
    </Wrapper>
  )
}

export default Tools

const Wrapper = styled.div`
  padding: 0 20px;
`

const PageHeader = styled.div`
  font-size: 24px;
  margin-bottom: 24px;
`

const CardsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
